import { createStore, applyMiddleware } from 'redux';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import createRootReducer from './reducers';
import sagas from './sagas';
import history from './history';

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  createRootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware, thunk)
  ),
);

const persistor = persistStore(store);
// persistor.purge();

sagaMiddleware.run(sagas, persistor, history);

export default store;
